<div class="ui-control ui-inline-control" [formGroup]="formGroup">
  <span class="input-label">{{inputData.label}}</span>
  <p-dropdown class="input-control" [options]="dropdownOptions" [autoDisplayFirst]="false" optionLabel="name" showClear="true"
    [appendTo]="'body'" [formControlName]="inputData.colName"></p-dropdown>
</div>